import UpdatedAt from './updatedAt';
import Description from './description';
import {HistoryType, addToHistory} from "../client/local-history.client";
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';

// Used in both web app and chrome extension - test both!

export interface RepoResult {
  repo_name: string;
  description?: string;
  pushedAt?: string;
  stargazerCount?: number;
  updatedLabel?: string;
  pushedAtFormatted?: string;
}

function viewOnGHClick(repoName: string) {
  addToHistory(HistoryType.RepoVisit, repoName);
}

export function RepoListItem(
  {repoResult, children}: {repoResult: RepoResult, children: React.ReactNode}) {
  const starCount: number = repoResult.stargazerCount ?? 0;

  return (
    <li className="py-3 hover:bg-gray-50 dark:hover:bg-gray-700">
      <div className="flex items-center">
        {children}
        <div className="tooltip flex items-center">
          {/* Tooltip fix - https://claude.ai/chat/09d6407a-f819-48cf-a66b-251e1e9e6db8 */}
          <span className="tooltip-content">View on GitHub</span>
          <a 
            href={`https://github.com/${repoResult.repo_name}`} 
            target="_blank" 
            onClick={() => viewOnGHClick(repoResult.repo_name)} 
            className="ml-1 inline-flex items-center" 
            aria-label={`View "${repoResult.repo_name}" on GitHub`}
          >
            <ArrowTopRightOnSquareIcon className="inline-block size-4 text-gray-400" />
          </a>
        </div>
      </div>
      {/* TODO: description (font size 16) (https://github.com/collections/github-browser-extensions) */}
      {/* TODO: fix nan, None */}
      {(repoResult.description !== 'None' && repoResult.description !== 'nan') && 
      <div className="py-1 text-sm text-rr-medium">
        <span><Description description={repoResult.description} maxLength={137} /></span>
      </div>
      }
      <div className="text-xs text-rr-light">
        {starCount > 0 && <span className="mr-2">☆{starCount.toLocaleString()}</span>}
        <UpdatedAt updatedLabel={repoResult.updatedLabel} pushedAtFormatted={repoResult.pushedAtFormatted} />
      </div>
    </li>
  );
}